import ModelUtil from '@leverege/model-util';
import DetailListModel from "../shared/DetailListModel.js";
const TYPE = 'detail.RolloverType';

// This holds the information specific to a rollover type.
// In particular, overrides for the placement on screen and
// at cursor. This contains a detail list

function create(objectType) {
  return {
    type: TYPE,
    objectType: objectType || null,
    visible: true,
    placement: null,
    // null or top/bottom/top-left/etc. Null means no override
    atPointPlacement: null,
    // null, none, or top/bottom/top-left/etc. Null means no override
    details: DetailListModel.create()
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('visible'),
  ...ModelUtil.createAllValue('placement'),
  ...ModelUtil.createAllValue('atPointPlacement'),
  ...ModelUtil.createAllValue('details')
};